export const QUOTE_CONSTANT = {
    SHOW_PRODUCT_FOR: " Show Products For:",
    INITIATE_APPLICATION:" Initiate Application",
    NO_PRODUCT_ADDED:"No Product Added",
    SELECT_PRODUCT:"Select product(s) to proceed further",
    SELECT_STATE:'Select State to see the available carriers',
    ADMITTED_CARRIERS:'Admitted Carriers',
    NON_ADMITTED_CARRIERS : "Non Admitted Carriers",
    START_APPLICATION:"Start Application",
    ALL:'ALL',
    US:'us',
    PLEASE_SELECT_STATE:'Please Select State',
    STATE:'State',
    PRODUCT_NOT_AVAILABLE:'Products Not Available',
    NO_INDICATION_SELECTED:'No Indication Selected',
    NO_QUOTE_SELECTED:'No Quote Selected',
    QUOTE_IN_PROCESS:'Selected Quote is in processing state', 
    PLEASE_SELECT_QUOTE:'Select a Quote from left panel ',
    SELECT_TO_PROCEED:'Click “Proceed to Quote” button on the Quote card to proceed further',
    PLEASE_TRY_DIFFERENT_PRODUCT:'Please try different product, state combination',
    SELECT_INDICATION_TO_PROCEED:'Select Indication to proceed further',
    SELECT_QUOTE_TO_BIND:'Select Quote/ Click on Continue to Bind button to proceed further.',
    CARRIER_NOT_AVAILABLE:'Carriers are not available for this state.',
    ACCOUNT_NAME:'Account Name',
    AGENCY_NAME:'Agency Name',
    AGENT_NAME:'Agent Name',
    SELECT_MULTIPLE_INDICATION:'You can select multiple indications to submit for quote',
    SELECTED_INDICATIONS:'Selected Indications',
    MULTIPLE_SELECTIONS:'Multiple indications can be selected'
};
